

import App from './App';
import * as serviceWorker from './serviceWorker';

// ReactDOM.render(
//   <React.Fragment>
//     {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
//     <App />
//   </React.Fragment>,
//   document.getElementById('root'),
// );




import React from "react";
import ReactDOM from "react-dom";
import { createRoot } from 'react-dom/client';

import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import Button from "@mui/material/Button";

const themeLight = createTheme({
  palette: {
    background: {
      default: "#e4f0e2"
    }
  }
});

const themeDark = createTheme({
  palette: {
    background: {
      default: "#222222"
    },
    text: {
      primary: "#ffffff"
    }
  }
});

const IndexApp = () => {
  const [light, setLight] = React.useState(true);
  return (
    <ThemeProvider theme={light ? themeLight : themeDark}>
      <CssBaseline />
      {/* <Button onClick={() => setLight((prev) => !prev)}>Toggle Theme</Button> */}
      <App /> 
    </ThemeProvider>
  );
};

const rootElement = document.getElementById("root");
const root = createRoot(rootElement); // createRoot(container!) if you use TypeScript
root.render(<IndexApp />);



// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
